<template>
  <div>
    <v-card v-if="participantes[0].id_participante">
      <v-card-title>
        <v-layout row wrap>
          <v-flex xs3>CNPJ</v-flex>
          <v-flex xs7>Razão Social</v-flex>
          <v-flex xs2>% Participação</v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text class="card-height">
        <v-layout
          v-for="(participante, index) in participantes"
          :key="index"
          row
          wrap
          pb-3
        >
          <v-flex xs3 v-html="participante.documento" />
          <v-flex xs7 v-html="participante.nome" />
          <v-flex xs2 v-html="participante.porcentagem + ' %'" />
          <v-flex xs12 v-if="index != participantes.length - 1">
            <v-divider class="limite-divider"></v-divider>
          </v-flex>
        </v-layout>

        <v-layout v-if="!participantes.length">
          <v-flex xs12 text-xs-center pb-4>Nenhum registro encontrado</v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

    <v-card v-else>
      <v-card-title>
        <v-flex xs2>Grupo Econômico</v-flex>
      </v-card-title>
      <v-card-text class="card-height">
        <div class="layout">
          <v-data-table
            v-if="participantes"
            :headers="headers"
            :items="participantes"
            :pagination.sync="pagination"
            :rows-per-page-items="[10, 20]"
            :no-data-text="'Nenhum grupo econômico encontrado.'"
            :rows-per-page-text="'Linhas por página'"
            class="class-on-data-table"
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td
                  class="text-xs-left sm-column"
                  v-if="props.item.lider == false"
                >
                  {{ convertEconomicGroup(props.item.nr_cnpj_cpf) }}
                </td>
                <td
                  class="text-xs-left sm-column pointer"
                  @click="routerNewTarget(props.item.nr_cnpj_cpf)"
                  v-else
                >
                  {{ convertEconomicGroup(props.item.nr_cnpj_cpf) }}
                </td>

                <td
                  class="text-xs-left xl-column"
                  v-if="props.item.lider == false"
                >
                  {{ props.item.nome }}
                </td>
                <td
                  class="text-xs-left xl-column pointer"
                  @click="routerNewTarget(props.item.nr_cnpj_cpf)"
                  v-else
                >
                  {{ props.item.nome }}
                </td>

                <td
                  class="text-xs-center"
                  v-if="props.item.limite_credito_geral_aprovado == null"
                >
                  -
                </td>
                <td
                  class="text-xs-center sm-column pointer"
                  @click="routerNewTarget(props.item.nr_cnpj_cpf, 2)"
                  v-else
                >
                  {{ toMoneyString(props.item.limite_credito_geral_aprovado) }}

                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <i
                        data-v-214d91de=""
                        aria-hidden="true"
                        v-bind="attrs"
                        v-on="on"
                        class="
                          v-icon
                          icon-blue
                          v-icon--link
                          material-icons
                          theme--light
                        "
                        >info</i
                      >
                    </template>
                    <span>
                      Clique aqui para visualizar os Limites de Créditos
                      detalhados
                    </span>
                  </v-tooltip>
                </td>

                <td
                  class="text-xs-center"
                  v-if="props.item.valor_total_acumulado == null"
                >
                  -
                </td>
                <td
                  class="text-xs-center sm-column pointer"
                  @click="routerNewTarget(props.item.nr_cnpj_cpf, 8)"
                  v-else
                >
                  {{ toMoneyString(props.item.valor_total_acumulado) }}

                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <i
                        data-v-214d91de=""
                        aria-hidden="true"
                        v-bind="attrs"
                        v-on="on"
                        class="
                          v-icon
                          icon-blue
                          v-icon--link
                          material-icons
                          theme--light
                        "
                        >info</i
                      >
                    </template>
                    <span>
                      Clique aqui para visualizar a lista de Apólices que
                      compõem este acúmulo
                    </span>
                  </v-tooltip>
                </td>

                <td
                  class="text-xs-center"
                  v-if="props.item.limite_credito_disponivel == null"
                >
                  -
                </td>
                <td
                  class="text-xs-center sm-column pointer"
                  @click="routerNewTarget(props.item.nr_cnpj_cpf, 2)"
                  v-else
                >
                  {{ toMoneyString(props.item.limite_credito_disponivel) }}

                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <i
                        data-v-214d91de=""
                        aria-hidden="true"
                        v-bind="attrs"
                        v-on="on"
                        class="
                          v-icon
                          icon-blue
                          v-icon--link
                          material-icons
                          theme--light
                        "
                        >info</i
                      >
                    </template>
                    <span>
                      Clique aqui para visualizar os Limites de Créditos
                      detalhados
                    </span>
                  </v-tooltip>
                </td>

                <td
                  class="text-xs-center"
                  v-if="props.item.situacao_cad == null"
                >
                  -
                </td>
                <td
                  class="text-xs-center pointer"
                  @click="routerNewTarget(props.item.nr_cnpj_cpf, 2)"
                  v-else
                >
                  <v-tooltip right v-if="props.item.situacao_cad === 'Verde'">
                    <template v-slot:activator="{ on, attrs }">
                      <i
                        data-v-214d91de=""
                        aria-hidden="true"
                        v-bind="attrs"
                        v-on="on"
                        class="
                          v-icon
                          icon-green
                          v-icon--link
                          material-icons
                          theme--light
                        "
                        >check_circle</i
                      >
                    </template>
                    <span> Aprovado </span>
                  </v-tooltip>

                  <v-tooltip
                    right
                    v-if="props.item.situacao_cad === 'Vermelho'"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <i
                        data-v-214d91de=""
                        aria-hidden="true"
                        v-bind="attrs"
                        v-on="on"
                        class="
                          v-icon
                          icon-red
                          v-icon--link
                          material-icons
                          theme--light
                        "
                        >error</i
                      >
                    </template>
                    <span>
                      Clique aqui para informações mais detalhadas da Situação
                      do tomador
                    </span>
                  </v-tooltip>
                </td>

                <td
                  class="text-xs-center"
                  v-if="props.item.dt_validade_cad == null"
                >
                  -
                </td>
                <td
                  class="text-xs-center pointer"
                  @click="routerNewTarget(props.item.nr_cnpj_cpf)"
                  v-else
                >
                  {{ formatDate(props.item.dt_validade_cad) }}
                </td>

                <td class="text-xs-center" v-if="props.item.status_ccg == null">
                  -
                </td>
                <td
                  class="text-xs-center pointer"
                  @click="routerNewTarget(props.item.nr_cnpj_cpf, 3)"
                  v-else
                >
                  <v-tooltip left v-if="props.item.status_ccg === 'Verde'">
                    <template v-slot:activator="{ on, attrs }">
                      <i
                        data-v-214d91de=""
                        aria-hidden="true"
                        v-bind="attrs"
                        v-on="on"
                        class="
                          v-icon
                          icon-green
                          v-icon--link
                          material-icons
                          theme--light
                        "
                        >check_circle</i
                      >
                    </template>
                    <span>
                      Clique aqui para informações mais detalhadas do CCG
                    </span>
                  </v-tooltip>

                  <v-tooltip left v-if="props.item.status_ccg === 'Vermelho'">
                    <template v-slot:activator="{ on, attrs }">
                      <i
                        data-v-214d91de=""
                        aria-hidden="true"
                        v-bind="attrs"
                        v-on="on"
                        class="
                          v-icon
                          icon-red
                          v-icon--link
                          material-icons
                          theme--light
                        "
                        >error</i
                      >
                    </template>
                    <span>
                      O CCG deste tomador ainda não foi confeccionado, clique
                      aqui para preencher solicitar a assinatura do CCG
                    </span>
                  </v-tooltip>

                  <v-tooltip left v-if="props.item.status_ccg === 'Amarelo'">
                    <template v-slot:activator="{ on, attrs }">
                      <i
                        data-v-214d91de=""
                        aria-hidden="true"
                        v-bind="attrs"
                        v-on="on"
                        class="
                          v-icon
                          icon-yellow
                          v-icon--link
                          material-icons
                          theme--light
                        "
                        >error</i
                      >
                    </template>
                    <span>
                      O CCG deste tomador já foi confeccionado, porém, não foi
                      Formalizado, clique aqui para informações mais detalhadas
                    </span>
                  </v-tooltip>
                </td>

                <td
                  class="text-xs-center"
                  v-if="props.item.documentacao == null"
                >
                  -
                </td>
                <td
                  class="text-xs-center pointer"
                  @click="routerNewTarget(props.item.nr_cnpj_cpf, 4)"
                  v-else
                >
                  <v-tooltip left v-if="props.item.documentacao === 'Verde'">
                    <template v-slot:activator="{ on, attrs }">
                      <i
                        data-v-214d91de=""
                        aria-hidden="true"
                        v-bind="attrs"
                        v-on="on"
                        class="
                          v-icon
                          icon-green
                          v-icon--link
                          material-icons
                          theme--light
                        "
                        >check_circle</i
                      >
                    </template>
                    <span> Não existe documentação pendente do tomador </span>
                  </v-tooltip>

                  <v-tooltip left v-if="props.item.documentacao === 'Vermelho'">
                    <template v-slot:activator="{ on, attrs }">
                      <i
                        data-v-214d91de=""
                        aria-hidden="true"
                        v-bind="attrs"
                        v-on="on"
                        class="
                          v-icon
                          icon-red
                          v-icon--link
                          material-icons
                          theme--light
                        "
                        >error</i
                      >
                    </template>
                    <span>
                      Clique aqui para acessar a tela de documentação do tomador
                    </span>
                  </v-tooltip>

                  <v-tooltip left v-if="props.item.documentacao === 'Amarelo'">
                    <template v-slot:activator="{ on, attrs }">
                      <i
                        data-v-214d91de=""
                        aria-hidden="true"
                        v-bind="attrs"
                        v-on="on"
                        class="
                          v-icon
                          icon-yellow
                          v-icon--link
                          material-icons
                          theme--light
                        "
                        >error</i
                      >
                    </template>
                    <span> A documentação enviada está sendo analisada </span>
                  </v-tooltip>
                </td>

                <td class="text-xs-center" v-if="props.item.lider == false">
                  {{ addPercent(props.item.pe_participacao) }}
                </td>
                <td
                  class="text-xs-center pointer"
                  @click="routerNewTarget(props.item.nr_cnpj_cpf)"
                  v-else
                >
                  {{ addPercent(props.item.pe_participacao) }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script lang="js">
import { formatCNPJ, formatDate, toMoneyString, convertEconomicGroup, addPercent } from "@/libs/utils";

export default {
  name: "TomadorParticipantes",
  
  props: ["participantes"],

  data: ()=> ({
    formatCNPJ,
    formatDate,
    toMoneyString,
    convertEconomicGroup,
    addPercent,
    pagination: {},
    routerData: null,
    headers: [
      {
        text: "CNPJ / CPF Tomador",
        align: "left",
        sortable: false,
      },
      {
        text: "Razão Social",
        align: "left",
        sortable: false,
      },
      {
        text: "Limite de Crédito Geral Aprovado",
        align: "center",
        sortable: false,
      },
      {
        text: "Valor Total Acumulado",
        align: "center",
        sortable: false,
      },
      {
        text: "Limite de Crédito Geral Disponível",
        align: "center",
        sortable: false,
      },
      {
        text: "Situação Cadastral",
        align: "center",
        sortable: false,
      },
      {
        text: "Validade Cadastro",
        align: "center",
        sortable: false,
      },
      {
        text: "Status CCG",
        align: "center",
        sortable: false,
      },
      {
        text: "Documentação",
        align: "center",
        sortable: false,
      },
      {
        text: "% Participação",
        align: "center",
        sortable: false,
      }
    ],
  }),
  methods: {
    routerNewTarget(cnpj_cpf, screen = 1){
      let router = this.$router.resolve({path: `/tomadores/${cnpj_cpf}/${screen}`,});
      let href = router.href;
      window.open(href, '_blank');
    }
  },
};

</script>

<style lang="scss" scoped>
#jns {
  $greenColor: #38b000;
  $whiteColor: #ffffff;
  $redColor: #d00000;
  $blueColor: #282498;
  $yellowColor: #f0ed20;

  .v-card__title {
    background-color: #efefef;
    font-size: 14px;
    font-weight: bolder;
    color: #191737;
    margin-bottom: 20px;
  }

  .icon-green {
    color: $greenColor;
    cursor: pointer;
  }

  .icon-red {
    color: $redColor;
    cursor: pointer;
  }

  .icon-blue {
    color: $blueColor;
    cursor: pointer;
  }

  .icon-yellow {
    color: $yellowColor;
    cursor: pointer;
  }

  .sm-column {
    min-width: 200px;
    width: 200px;
    max-width: 200px;
  }

  .md-column {
    min-width: 300px;
    width: 350px;
    max-width: 350px;
  }

  .lg-column {
    min-width: 500px;
    width: 550px;
    max-width: 500px;
  }

  .xl-column {
    min-width: 500px;
    width: 500px;
    max-width: 600px;
  }

  .layout {
    display: inline-block;
    width: 100%;
  }

  td.pointer {
    cursor: pointer;
  }
}
</style>


// WEBPACK FOOTER //
// ./src/components/TomadorParticipantes.vue